<template>
  <el-dialog custom-class="medium-dialog" title="修改地址" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true"
  >
    <el-row>
      <el-col :span="24">
        <!-- 新增地址区域 -->
        <div style="margin-top:12px;border-top:1px solid #dcdfe6;padding-top:10px;">
          <el-button type="primary" size="mini" @click="showAddForm = !showAddForm">
            {{ showAddForm ? '收起新增' : '新增地址' }}
          </el-button>
          <el-form v-if="showAddForm" :model="newAddress" :rules="addressRules" ref="addressForm"
                   size="mini" label-width="80px" style="margin-top:10px;">
            <el-form-item label="粘贴解析">
              <el-input type="textarea" v-model="parseText" :rows="2" style="width:400px;vertical-align:top;"
                        placeholder="粘贴客服复制的文字，自动解析联系人/电话/省市区/地址，可手动修正"></el-input>
              <el-button type="primary" size="mini" style="margin-left:8px;vertical-align:top;"
                         @click="parseAddressText">解析并填入</el-button>
            </el-form-item>
            <el-form-item label="联系人" prop="uname">
              <el-input v-model="newAddress.uname" style="width:200px;" placeholder="请输入联系人"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="mobile">
              <el-input v-model="newAddress.mobile" style="width:200px;" placeholder="请输入联系电话"
                        @input="newAddress.mobile = newAddress.mobile.replace(/\D/g, '')"></el-input>
            </el-form-item>
            <el-form-item label="省市区" prop="region">
              <v-distpicker :province="newAddress.province" @province="onChangeProvince" :city="newAddress.city"
                            @city="onChangeCity" :area="newAddress.county" @area="onChangeArea"
                            :key="distpickerKey"></v-distpicker>
            </el-form-item>
            <el-form-item label="收货地址" prop="address">
              <el-input v-model="newAddress.address" style="width:400px;" placeholder="请输入详细收货地址"></el-input>
            </el-form-item>
            <el-form-item label="排序">
              <el-input v-model="newAddress.sort" style="width:200px;" placeholder="排序值(越大越靠前，默认地址用最大)"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="success" size="mini" @click="saveNewAddress" :loading="savingAddress">保存地址</el-button>
              <span style="color:#909399;font-size:12px;margin-left:8px;">新增的地址将保存到客户地址库，可在列表中选中使用</span>
            </el-form-item>
          </el-form>
        </div>
        <el-table
          :data="addressData"
          ref="moviesTable"
          size="mini"
          stripe
          border
          @selection-change="handleSelectionChange"
          style="width: 100%;">
          <el-table-column
            type="selection"
            width="80">
          </el-table-column>

          <el-table-column
            prop="uname"
            label="联系人"
            align="left"
            width="150"
            header-align="center">
          </el-table-column>

          <el-table-column
            prop="mobile"
            label="联系电话"
            align="center"
            header-align="center"
            width="180">
          </el-table-column>

          <el-table-column
            prop="deliveryaddress"
            label="收货地址"
            align="center"
            header-align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.deliveryaddress }}</span>
              <el-tag v-if="scope.row.defalut == '1' || scope.row.defalut == 1" size="mini" type="danger" style="margin-left:6px;">默认</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            label="排序"
            align="center"
            header-align="center"
            width="120">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.defalut == '1' || scope.row.defalut == 1" size="mini" type="danger">默认</el-tag>
              <a v-else style="cursor:pointer;color:#409EFF;"
                 @click="openSortDialog(scope.row)">{{ scope.row.sort != null && scope.row.sort != '' ? scope.row.sort : 0 }}</a>
            </template>
          </el-table-column>

        </el-table>

        <!-- 修改排序小弹框 -->
        <el-dialog title="修改排序" :visible.sync="sortDialogVisible" width="360px" :append-to-body="true"
                   :close-on-click-modal="false">
          <el-form size="mini" label-width="80px">
            <el-form-item label="排序值">
              <el-input v-model="sortInput" placeholder="越大越靠前"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="sortDialogVisible = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="saveSort" :loading="savingSort">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :disabled="isDisable">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>

  import {saveCstagreementData} from '@/api/set/csagreement';
  import {getAddressListData, saveAddressForCustomer} from '@/api/set/parameter';
  import {saveData as saveHandlelog} from '@/api/set/handlelog';
  import {updateAddress} from '@/api/set/address';
  // 省市区字典（与 v-distpicker 同源，用于文本解析时按名称匹配）
  import provinceDict from '@/components/common/distpicker2/province.js';
  import cityDict from '@/components/common/distpicker2/city.js';
  import areaDict from '@/components/common/distpicker2/area.js';

  export default {
    name: "选择地址",
    data() {
      return {
        isDisable: false,
        dialogFormVisible: false,
        form: {
          unitguid: '',//表单数据
          deliveryaddress: '',
          linkman: '',
          linkmantel: ''
        },
        tabledata: [],
        addressData: [],
        erpserial: '',
        customerserial: '',
        showAddForm: false,
        savingAddress: false,
        sortDialogVisible: false,
        savingSort: false,
        sortInput: '',
        sortRow: null,
        newAddress: {
          uname: '',
          mobile: '',
          province: '',
          city: '',
          county: '',
          address: '',
          sort: ''
        },
        parseText: '',
        distpickerKey: 0,
        addressRules: {
          uname: [
            {required: true, message: '请输入联系人', trigger: 'blur'}
          ],
          mobile: [
            {required: true, message: '请输入联系电话', trigger: 'blur'},
            {pattern: /^\d+$/, message: '联系电话只能输入数字', trigger: 'blur'}
          ],
          // 省市区必选：v-distpicker 是一个组件含三级下拉，用虚拟字段 region 统一校验三者的非空
          region: [
            {
              validator: (rule, value, callback) => {
                if (!this.newAddress.province) return callback(new Error('请选择省'));
                if (!this.newAddress.city) return callback(new Error('请选择市'));
                if (!this.newAddress.county) return callback(new Error('请选择区/县'));
                callback();
              },
              trigger: 'change'
            }
          ],
          address: [
            {required: true, message: '请输入收货地址', trigger: 'blur'}
          ]
        },
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          deliveryaddress: [
            {required: true, message: '请选择联系地址', trigger: 'blur'},
          ],
          linkman: [
            {required: true, message: '请输入联系人', trigger: 'blur'},
          ],
          linkmantel: [
            {required: true, message: '请输入联系电话', trigger: 'blur'},
          ]
        },
      }
    },
    methods: {
      show(item) {
        this.initForm();
        this.dialogFormVisible = true;
        this.form.unitguid=item.unitguid
        this.erpserial=item.erpserial||''
        this.customerserial=item.customerserial||''
        this.showAddForm=false
        this.newAddress={uname:'',mobile:'',province:'',city:'',county:'',address:'',sort:''}
        this.parseText=''
        this.savingAddress=false
        getAddressListData({customerserial: item.customerserial}).then(response => {
          this.addressData = response.data.obj
          for (let i in this.addressData) {
            this.addressData[i]["deliveryaddress"] = this.getAddressStr(this.addressData[i])
          }
          this.sortAddressData();
        })
      },
      //省市区选择事件：占位值（省/市/区/县）转为空字符串
      onChangeProvince(data) {
        if (data.value == '省') data.value = '';
        this.newAddress.province = data.value;
        this.clearRegionValidate();
      },
      onChangeCity(data) {
        if (data.value == '市') data.value = '';
        this.newAddress.city = data.value;
        this.clearRegionValidate();
      },
      onChangeArea(data) {
        if (data.value == '区' || data.value == '县') data.value = '';
        this.newAddress.county = data.value;
        this.clearRegionValidate();
      },
      //选择省市区后清除 region 校验错误（省市区必选提示）
      clearRegionValidate() {
        if (this.$refs.addressForm) {
          this.$refs.addressForm.clearValidate('region');
        }
      },
      //在文本中查找 names（含 code），from 位置之后最早出现的名字，返回 {name, code, index}；未找到返回 null
      findFirstRegion(list, str, from) {
        let best = null;
        for (let i = 0; i < list.length; i++) {
          const idx = str.indexOf(list[i].name, from);
          if (idx !== -1 && (!best || idx < best.index)) {
            best = {name: list[i].name, code: list[i].code, index: idx};
          }
        }
        return best;
      },
      //清理详细地址：去掉开头遗留的字段标签、残留标签词、结尾邮编、首尾分隔符
      cleanAddress(str) {
        let s = String(str || '');
        //反复去掉开头的字段标签（省份： 城市： 区县： 街道： 地址： 电话： 等）
        for (let i = 0; i < 12; i++) {
          const before = s;
          s = s.replace(/^([\s,，。;；、|:：()（）【】\[\]_-]*)(省份|城市|区县|县区|省市区|地区|街道|地址|收货地址|送货地址|详细地址|联系电话|联系方式|电话|手机|联系人|收货人|收件人|姓名)\s*[:：]?\s*/, '');
          if (s === before) break;
        }
        //去掉残留的字段标签词（已提取出联系人等信息后，这些词不应再出现在地址里）
        s = s.replace(/(联系电话|手机号码|手机号|联系方式|联系人|收货人|收件人|姓名|区县|县区|省份)\s*[:：]?\s*/g, '');
        //去掉结尾的邮编
        s = s.replace(/(邮编|邮政编码|邮编码)\s*[:：]?\s*\d{5,6}\s*$/, '');
        //清理首尾分隔符/空白
        s = s.replace(/^[\s,，。;；、|:：()（）【】\[\]_-]+/, '')
          .replace(/[\s,，。;；、|:：()（）【】\[\]_-]+$/, '');
        return s;
      },
      //粘贴文本智能解析：无固定格式，启发式提取 联系人/电话/省市区/详细地址，填入表单后可手动修正
      parseAddressText() {
        const t0 = String(this.parseText || '').trim();
        if (!t0) {
          this.$message({message: '请先粘贴地址文本', type: 'warning'});
          return;
        }
        let t = t0;
        const result = {uname: '', mobile: '', province: '', city: '', county: '', address: ''};
        //1. 电话（最可靠）：手机号优先，否则座机；正则带数字边界，避免匹配到订单号/日期片段中的数字
        let phoneRaw = '', phoneIndex = -1;
        let m1 = t.match(/(^|[^\d])(1[3-9]\d{9})([^\d]|$)/);
        if (m1) {
          phoneRaw = m1[2];
          phoneIndex = m1.index + m1[1].length;
        } else {
          const m2 = t.match(/(^|[^\d])(0\d{2,3}-?\d{7,8})([^\d]|$)/);
          if (m2) {
            phoneRaw = m2[2];
            phoneIndex = m2.index + m2[1].length;
          }
        }
        if (phoneRaw) result.mobile = phoneRaw.replace(/-/g, '');
        //2. 省市区（字典匹配）
        let provinceMatch = null, cityMatch = null, areaMatch = null, regionEnd = -1;
        //省：所有省名中最先出现者
        const provList = [];
        for (const code in provinceDict) provList.push({name: provinceDict[code], code: code});
        provinceMatch = this.findFirstRegion(provList, t, 0);
        if (provinceMatch) {
          result.province = provinceMatch.name;
          //市：优先匹配该省下的市名（排除跨省同名）
          const cityMap = cityDict[provinceMatch.code] || {};
          const cityList = [];
          for (const code in cityMap) cityList.push({name: cityMap[code], code: code});
          cityMatch = this.findFirstRegion(cityList, t, provinceMatch.index + provinceMatch.name.length);
          //直辖市（北京市/天津市/上海市/重庆市）等单市省份：省名即市名，文本中不会再出现第二段同名市
          if (!cityMatch) {
            const single = cityList.length === 1 ? cityList[0] : cityList.filter(c => c.name === provinceMatch.name)[0];
            if (single) cityMatch = {name: single.name, code: single.code, index: -1};
          }
          if (cityMatch) result.city = cityMatch.name;
        } else {
          //省未匹配（如文本只写了市/区）：全局市名兜底，再反推省
          for (const pcode in cityDict) {
            const cityMap = cityDict[pcode];
            for (const code in cityMap) {
              const idx = t.indexOf(cityMap[code]);
              if (idx !== -1 && (!cityMatch || idx < cityMatch.index)) {
                cityMatch = {name: cityMap[code], code: code, index: idx};
              }
            }
          }
          if (cityMatch) {
            const provCode = String(cityMatch.code).slice(0, 2) + '0000';
            if (provinceDict[provCode]) {
              provinceMatch = {name: provinceDict[provCode], code: provCode, index: -1};
              result.province = provinceMatch.name;
              result.city = cityMatch.name;
            }
          }
        }
        //区/县：限定在该市的区列表内匹配（避免各市同名区 like 朝阳区/西湖区 错配）
        if (cityMatch) {
          const areaMap = areaDict[cityMatch.code] || {};
          const areaList = [];
          for (const code in areaMap) areaList.push({name: areaMap[code], code: code});
          const areaFrom = cityMatch.index >= 0 ? cityMatch.index + cityMatch.name.length
            : (provinceMatch && provinceMatch.index >= 0 ? provinceMatch.index + provinceMatch.name.length : 0);
          areaMatch = this.findFirstRegion(areaList, t, areaFrom);
          if (areaMatch) result.county = areaMatch.name;
          //记录区域在原文中的结束位置（详细地址提取用）
          if (areaMatch) {
            regionEnd = areaMatch.index + areaMatch.name.length;
          } else if (cityMatch.index >= 0) {
            regionEnd = cityMatch.index + cityMatch.name.length;
          } else if (provinceMatch && provinceMatch.index >= 0) {
            regionEnd = provinceMatch.index + provinceMatch.name.length;
          }
        } else if (provinceMatch && provinceMatch.index >= 0) {
          regionEnd = provinceMatch.index + provinceMatch.name.length;
        }
        //3. 联系人（启发式）
        const nameRe = /(联系人|收货人|收件人|姓名|联系人姓名|客户姓名)\s*[:：]?\s*([一-龥]{2,4})/;
        const nameMatch = t.match(nameRe);
        let nameLabel = '';
        if (nameMatch) {
          result.uname = nameMatch[2];
          nameLabel = nameMatch[0];
        } else if (phoneIndex >= 0) {
          //电话之前、以分隔符隔开的最后一段连续中文（2-4字）作为联系人
          const pre = t0.slice(0, phoneIndex);
          const preMatch = pre.match(/(^|[\s,，。;；、|:：()（）【】\[\]_-]+)([一-龥]{2,4})\s*$/);
          if (preMatch) result.uname = preMatch[2];
        }
        if (!result.uname) {
          //剩余文本开头第一段连续中文
          const leadMatch = t.match(/^[\s,，。;；、|:：()（）【】\[\]_-]*([一-龥]{2,4})/);
          if (leadMatch) result.uname = leadMatch[1];
        }
        //4. 从文本移除：联系人标签块、省市区名、电话（含"电话：/tel"等前缀）
        if (nameLabel) t = t.replace(nameLabel, '');
        if (result.uname) t = t.replace(result.uname, '');
        [result.province, result.city, result.county].forEach(n => {
          if (n) t = t.replace(n, '');
        });
        if (phoneRaw) {
          const phoneEsc = phoneRaw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const labelRe = new RegExp('(联系电话|手机号码|手机号|电话号码|电话|手机|座机|tel|Tel|TEL)\\s*[:：\\-—]?\\s*' + phoneEsc);
          const lm = t.match(labelRe);
          t = lm ? t.replace(lm[0], '') : t.replace(phoneEsc, '');
        }
        //5. 详细地址：优先取省市区结束位置之后的原文（区域名是地址部分的最强锚点），再做清理
        let address = '';
        if (regionEnd >= 0) {
          address = t0.slice(regionEnd);
          if (result.uname) address = address.replace(result.uname, '');
          if (phoneRaw) {
            const phoneEsc = phoneRaw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const labelRe = new RegExp('(联系电话|手机号码|手机号|电话号码|电话|手机|座机)\\s*[:：\\-—]?\\s*' + phoneEsc);
            const lm = address.match(labelRe);
            address = lm ? address.replace(lm[0], '') : address.replace(phoneEsc, '');
          }
        }
        address = this.cleanAddress(address);
        if (address.length < 4) {
          //原始区切片过短：用移除省市区/电话后的剩余文本兜底
          const later = this.cleanAddress(t);
          if (later.length > address.length) address = later;
        }
        result.address = address;
        //6. 填入表单并刷新省市区组件（:key 强制重渲染，读取已解析的省市区）
        this.newAddress = Object.assign({}, this.newAddress, {
          uname: result.uname,
          mobile: result.mobile,
          province: result.province,
          city: result.city,
          county: result.county,
          address: result.address
        });
        this.distpickerKey++;
        this.clearRegionValidate();
        //7. 反馈：未识别字段提示手动补充
        const miss = [];
        if (!result.province) miss.push('省');
        if (!result.city) miss.push('市');
        if (!result.county) miss.push('区/县');
        if (!result.uname) miss.push('联系人');
        if (!result.mobile) miss.push('电话');
        if (!result.address) miss.push('详细地址');
        if (miss.length) {
          this.$message({message: '已自动填入，未识别：' + miss.join('、') + '，请手动补充', type: 'warning'});
        } else {
          this.$message({message: '已自动填入，请核对后保存', type: 'success'});
        }
      },
      //拼接完整收货地址（省+市+县+详细地址），省市区为空/null/0 时忽略，避免地址前出现多余的"0"
      getAddressStr(row) {
        var region = [row.province, row.city, row.county];
        var str = '';
        for (var i = 0; i < region.length; i++) {
          var v = region[i];
          if (v == null || v === '' || v === '0' || v === 0) continue;
          str += v;
        }
        return str + (row.address || '');
      },
      //收货地址排序：默认地址最前，其余按 sort 降序（大的在前）
      sortAddressData() {
        this.addressData.sort(function (a, b) {
          var ad = (a.defalut == '1' || a.defalut == 1) ? 1 : 0;
          var bd = (b.defalut == '1' || b.defalut == 1) ? 1 : 0;
          if (ad != bd) return bd - ad;
          var asort = a.sort != null && a.sort != '' ? parseInt(a.sort) : 0;
          var bsort = b.sort != null && b.sort != '' ? parseInt(b.sort) : 0;
          if (asort != bsort) return bsort - asort;
          return 0;
        });
      },
      //打开修改排序弹框
      openSortDialog(row) {
        this.sortRow = row;
        this.sortInput = row.sort != null && row.sort != '' ? row.sort : 0;
        this.sortDialogVisible = true;
      },
      //保存修改排序
      saveSort() {
        if (!this.sortRow) return;
        if (this.sortRow.defalut == '1' || this.sortRow.defalut == 1) {
          this.$message({message: '默认地址无需修改排序', type: 'warning'});
          this.sortDialogVisible = false;
          return;
        }
        this.savingSort = true;
        var unitguid = this.sortRow.unitguid;
        var sort = this.sortInput == '' ? 0 : this.sortInput;
        updateAddress({paracontent: JSON.stringify({unitguid: unitguid, sort: sort})}).then(response => {
          if (response.data.code == 0) {
            this.sortRow.sort = sort;
            this.sortAddressData();
            this.$message({message: '排序修改成功', type: 'success'});
            this.sortDialogVisible = false;
          } else {
            this.$message({message: response.data.msg || '修改失败', type: 'error'});
          }
        }).finally(() => {
          this.savingSort = false;
        });
      },
      handleSelectionChange(val) {
        if (val && val.length > 0) {
          for (var i = 0; i < val.length - 1; i++) {
            this.$refs.moviesTable.toggleRowSelection(val[i], false)
          }
        }
        this.tabledata = val;
      },
      saveData() {
        if(this.tabledata.length>0){
          this.form.deliveryaddress = this.tabledata[0].deliveryaddress
          this.form.linkman = this.tabledata[0].uname
          this.form.linkmantel = this.tabledata[0].mobile
          saveCstagreementData(this.form).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.$emit('afertupdate', this.form.deliveryaddress, this.form.linkman, this.form.linkmantel);
              this.dialogFormVisible = false;
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
            }
          })
        }else {
          this.$message({
            message:'请选择地址',
            type: 'error'
          })
        }
      },
      saveNewAddress() {
        this.$refs.addressForm.validate((valid) => {
          if (!valid) return;
          this.savingAddress = true;
          var addr = this.newAddress;
          // 1. 保存地址到客户地址库
          saveAddressForCustomer({
            uname: addr.uname,
            mobile: addr.mobile,
            province: addr.province,
            city: addr.city,
            county: addr.county,
            address: addr.address,
            customerserial: this.customerserial,
            sort: addr.sort
          }).then(response => {
            if (response.data.code == 0) {
              // 2. 记录操作日志到handlelog
              saveHandlelog({
                erpserial: this.erpserial,
                casestepname: '新增地址',
                remark: '新增收货地址：' + addr.address + '，联系人：' + addr.uname + '，电话：' + addr.mobile,
                isopen: 1
              }).then(() => {
                // 3. 刷新地址列表
                getAddressListData({customerserial: this.customerserial}).then(resp => {
                  this.addressData = resp.data.obj
                  for (let i in this.addressData) {
                    this.addressData[i]["deliveryaddress"] = this.getAddressStr(this.addressData[i])
                  }
                  this.sortAddressData();
                });
                this.$message({message: '地址新增成功', type: 'success'});
                this.showAddForm = false;
                this.newAddress = {uname: '', mobile: '', province: '', city: '', county: '', address: '', sort: ''};
              }).catch(() => {
                this.$message({message: '地址已保存，但日志记录失败', type: 'warning'});
                this.showAddForm = false;
                this.newAddress = {uname: '', mobile: '', province: '', city: '', county: '', address: '', sort: ''};
              });
            } else {
              this.$message({message: response.data.msg || '保存地址失败', type: 'error'});
            }
          }).catch(() => {
            this.$message({message: '保存地址失败', type: 'error'});
          }).finally(() => {
            this.savingAddress = false;
          });
        });
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
      }
    },
    mounted() {
    },
    components: {},
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/UpdateAddress.vue